import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {DeliveryPointRemote} from "@app/core/delivery-point/domain/delivery-point.remote";
import {switchMap} from "rxjs/operators";
import {GeolocationService} from "@app/core/delivery-point/domain/geolocation.service";

/**
 * Use case for retrieving the postal code from the user's current location.
 */
@Injectable({
    providedIn: 'root',
})

export class GetPostalCodeFromCurrentLocationUseCase {

    constructor(
        private deliveryRepository:DeliveryPointRemote,
        private geolocationService:GeolocationService
    ) {}

    execute(): Observable<string> {
        return this.geolocationService.getCurrentPosition().pipe(
            switchMap(position =>
                this.deliveryRepository.getPostalCodeFromCoordinates(position.coords.latitude,position.coords.longitude)
            )
        );
    }

}